import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/hooks/use-api";
import type { ThemaSearchParams } from "~/api/client/thema";

interface UseThemaSearchProps {
  searchParams?: ThemaSearchParams;
  enabled?: boolean;
  keepPreviousData?: boolean;
}

export const useThemaSearch = ({
  searchParams,
  enabled = true,
  keepPreviousData = false,
}: UseThemaSearchProps) => {
  const api = useApi();

  return useQuery({
    queryKey: ["thema", "search", searchParams],
    queryFn: async () => {
      if (!searchParams) {
        throw new Error("Search parameters are required");
      }
      const response = await api.thema.search(searchParams);
      return response ?? undefined;
    },
    enabled: enabled && !!searchParams,
    staleTime: 5 * 60 * 1000, // 5 minutes - search results are relatively stable
    placeholderData: keepPreviousData
      ? (previousData) => previousData
      : undefined,
  });
};
